import { parseISO } from 'date-fns'
import dayjs from 'dayjs'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import { useAppDispatch, useAppSelector } from '../../../store'
import { TravelAbroadState, setMultiDates, setMultiDays } from '../../../store/travelAbroadSlice'
import DatePicker from '../../../components/v2/DatePicker'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import FraniBackgroundIcon from '../../../assets/v2/JSX/FraniBackgroundIcon'
import { toast } from 'react-toastify'
import { AppState } from '../../../store/appSlice'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { Helmet } from 'react-helmet-async'
//
//
const MultiSelectDate = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  // travel muldti days
  const { data: travelMultiDays, isLoading: isTravelMultiDaysLoading } = api.useGetTravelMultiDaysQuery(undefined)
  //
  //
  //
  const { t } = useTranslation()
  //
  //
  const navigate = useNavigate()
  //
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { travelAbroad: TravelAbroadState }) => data.travelAbroad)
  //
  //
  //
  //
  const clearDates = () => {
    dispatch(
      setMultiDates({
        start: null,
        end: null,
      }),
    )
  }
  //
  const maxDate = dayjs()
    .add(filter.multiDays?.validityPeriod as number, 'day')
    .format('YYYY-MM-DD')
  //
  //
  const [getLeftCompanies, { data: leftCompanies }] = api.useTravelAbrodLeftCompaniesMutation()
  //
  useEffect(() => {
    if (
      filter.productCategory &&
      filter.singleOrMulti &&
      filter.multiDates?.start &&
      filter.multiDates?.end &&
      filter.multiDays?.days
    ) {
      const GetCompaniesFunction = async () => {
        try {
          await getLeftCompanies({
            step: 'step-two',
            productCategory: filter.productCategory,
            startDate: filter.multiDates?.start as string,
            endDate: filter.multiDates?.end as string,
            multiDay: filter.multiDays?.days as number,
            travelType: filter.singleOrMulti,
          }).unwrap()
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (GetCompaniesFunction) (MultiSelectDate)')
          }
        }
      }
      //
      GetCompaniesFunction()
    }

    return () => {}
  }, [
    filter.singleOrMulti,
    filter.multiDates?.start,
    filter.multiDates?.end,
    filter.multiDays?.days,
    filter.productCategory,
    getLeftCompanies,
  ])
  //
  //
  return isTravelMultiDaysLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('multiSelectDateTitle')}</title>
        <meta name="description" content={`${t('multiSelectDateTitle')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('multiSelectDateTitle')} />

        <AbroadProgressBar stepName={`${t('duration')}`} />

        <Cards>
          {travelMultiDays &&
            travelMultiDays?.map((item, index) => {
              return (
                <HorizontalCard
                  className="horizontal-card"
                  key={index}
                  imgCHildren={
                    <>
                      <FraniBackgroundIconStyle />
                      <div className="icon-days">{item.days}</div>
                    </>
                  }
                  title={`${item?.days} ${t('day')}`}
                  description={item?.translations?.[lang]?.body}
                  selected={item.days === filter.multiDays?.days ? true : false}
                  onClick={() => {
                    if (filter.multiDates?.start && filter.multiDates?.end && item.days !== filter.multiDays?.days) {
                      return [
                        clearDates(),
                        dispatch(
                          setMultiDays({
                            days: item.days,
                            validityPeriod: item.days + item.insuredDays,
                          }),
                        ),
                      ]
                    } else {
                      dispatch(
                        setMultiDays({
                          days: item.days,
                          validityPeriod: item.days + item.insuredDays,
                        }),
                      )
                    }
                  }}
                >
                  {item.days === filter.multiDays?.days ? (
                    <CalendarBox>
                      <hr />
                      <DatePicker
                        minDate={new Date()}
                        maxDate={parseISO(maxDate) || undefined}
                        className="multi-start-date-class"
                        label={`${t('startDate')}`}
                        dateFormat="dd MMMM yyyy"
                        open={true}
                        selectedDate={filter.multiDates?.start ? parseISO(filter.multiDates.start as string) : null}
                        onchange={(value) => {
                          if (value && filter.multiDays?.validityPeriod) {
                            //
                            const plusMultiDay = dayjs(value).add(filter.multiDays?.validityPeriod as number, 'day')
                            const formatedEndDate = dayjs(plusMultiDay).format('YYYY-MM-DD')
                            //
                            if (plusMultiDay && formatedEndDate) {
                              dispatch(
                                setMultiDates({
                                  start: dayjs(value).format('YYYY-MM-DD'),
                                  end: formatedEndDate,
                                }),
                              )
                            }
                            //
                          }
                        }}
                      />
                    </CalendarBox>
                  ) : null}
                </HorizontalCard>
              )
            })}

          <RemainingCompanies
            style={{
              marginTop: '0px',
              opacity: leftCompanies ? '1' : '0',
            }}
            text={`${t('offerAvailable')}: ${leftCompanies?.length} `}
          />
        </Cards>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/single-or-multi')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              filter.productCategory &&
              filter.singleOrMulti &&
              leftCompanies &&
              leftCompanies.length >= 1 &&
              filter.multiDates?.start &&
              filter.multiDates?.end &&
              filter.multiDays?.days &&
              filter.multiDays?.validityPeriod
                ? false
                : true
            }
            onClick={() => navigate('/select-region')}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const FraniBackgroundIconStyle = styled(FraniBackgroundIcon)`
  height: 72px;

  ${Responsive.mobile} {
    height: 64px;
  }
`
const CalendarBox = styled.div`
  .react-datepicker-popper {
    position: unset !important;
    transform: unset !important;
    margin-top: 10px;
  }
  .react-datepicker {
    display: flex;
    justify-content: center;
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Cards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  max-width: 464px;
  margin-inline: auto;

  .image-div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .icon-days {
    position: absolute;
    top: 61px;
    font-size: 16px;
    color: ${Colors.primaryBlack};
    user-select: none;
  }

  .horizontal-card {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  ${Responsive.mobile} {
    margin-top: 24px;

    .icon-days {
      top: 62px;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .horizontal-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
  .react-datepicker-wrapper {
    width: 100%;
  }
`
//
export default MultiSelectDate
